// Configuration API spécifique au module Organisation
import { buildApiUrl as buildBaseApiUrl } from '../../../config/api';

export const buildApiUrl = (path: string): string => {
  return buildBaseApiUrl(`/organisation${path}`);
};

export { getDefaultHeaders } from '../../../config/api';
